import React from 'react';

function Header() {
  return (
    <header className="tc-header-style7">
      <div className="container">
        <h1> Creating Timeless Landscapes </h1>
        <div className="head-features">
          <p> Sustainable Solutions </p>
          <p> Competitive & Flexiable Price </p>
          <p> Innovative & Inspiring Designers </p>
        </div>
      </div>
      <div className="img">
        <img
          src="/home7_landscape/assets/img/header.jpg"
          alt=""
          className="img-cover"
          data-speed="1.25"
        />
      </div>
    </header>
  );
}

export default Header;
